import { render, staticRenderFns } from "./ucl-quiz-form.vue?vue&type=template&id=28114c60&scoped=true"
import script from "./ucl-quiz-form.vue?vue&type=script&setup=true&lang=js"
export * from "./ucl-quiz-form.vue?vue&type=script&setup=true&lang=js"
import style0 from "@ui-common/vue-select/dist/vue-select.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "@ui-common/vue-input/dist/vue-input.css?vue&type=style&index=1&prod&lang=css&external"
import style2 from "@ui-common/vue-checkbox/dist/vue-checkbox.css?vue&type=style&index=2&prod&lang=css&external"
import style3 from "@ui-common/vue-mobilephone-input/dist/vue-mobilephone-input.css?vue&type=style&index=3&prod&lang=css&external"
import style4 from "@ui-common/vue-error-message/dist/vue-error-message.css?vue&type=style&index=4&prod&lang=css&external"
import style5 from "@ui-common/vue-datepicker/dist/vue-datepicker.css?vue&type=style&index=5&prod&lang=css&external"
import style6 from "@ui-common/vue-captcha/dist/vue-captcha.css?vue&type=style&index=6&prod&lang=css&external"
import style7 from "./ucl-quiz-form.vue?vue&type=style&index=7&id=28114c60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28114c60",
  null
  
)

export default component.exports